import React, { useState } from 'react';
import { Button, useNotify, useRefresh } from 'react-admin';
import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import BorderColorIcon from '@material-ui/icons/BorderColor';

import { makeStyles } from '@material-ui/styles';
import { changeMade, thereWasProblem } from '../../Utils/messages';
import documentProvider from '../../Providers/documentProvider';

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: theme.spacing(1, 3),
  },
}));

interface EditI {
  record?: any;
}
const DocumentEditButton = ({ record }: EditI) => {
  const notify = useNotify();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const refresh = useRefresh();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const formData = new FormData();

  const fileInfo = {
    name: fileName,
  };
  formData.append('fileInfo', JSON.stringify(fileInfo));

  const handleSubmit = () => {
    setLoading(true);
    documentProvider
      .editDocument(formData, record?.documents[0]?.id)
      .then(() => {
        handleClose();
        notify(changeMade, 'success', {}, true);
        setLoading(false);
      })
      .catch((error) => {
        notify(
          `${thereWasProblem}: ${error.body?.data?.errors || 'Fallo general'}`,
          'warning'
        );
      })
      .finally(() => {
        setLoading(false);
        refresh();
      });
  };

  return (
    <div>
      <Tooltip title='Cambiar nombre'>
        <IconButton size='small' color='primary' onClick={handleClickOpen}>
          <BorderColorIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
      >
        <MuiDialogTitle id='form-dialog-title' disableTypography>
          <Typography variant='h4'>Cambiar nombre</Typography>
        </MuiDialogTitle>
        <DialogContent>
          <TextField
            defaultValue={record && record?.documents[0]?.name}
            fullWidth
            label='Nombre'
            margin='dense'
            onChange={(e) => setFileName(e.target.value)}
            type='text'
            variant='outlined'
          />
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            label='CANCELAR'
            onClick={() => handleClose()}
            color='primary'
          />
          <Button
            label='ACEPTAR'
            onClick={handleSubmit}
            color='primary'
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DocumentEditButton;
